<template>
  <div class="container bg-light my-3 py-3 px-4">

    <div class="row">
      <div class="col-12">
        <h2 class="ms-4 text-start">New Notification</h2>
        <hr>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12 col-lg-6">
        <ca-smtt-input 
          type="text"
          label="Title"
          @input="(e) => this.title = e.target.value"
        />
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12 col-lg-6">
        <ca-smtt-input 
        type="text"
        label="Message"
        @input="(e) => this.message = e.target.value"
        />
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12 col-lg-6">
        <ca-smtt-multiselect
          ref="groups"
          name="name"
          label="Groups to send the notification"
          :multipleSelection="true"
          :closeOnSelect="false"
          :optionsToSelect="groupsToAdd"
          :initialValue="[]"
          @handleAddTagging="addGroup"
        />
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12 col-lg-6">
        <ca-smtt-multiselect 
          ref="users"
          name="name"
          label="Users to whom send the notification"
          placeholderToTag="Add"
          :multipleSelection="true"
          :closeOnSelect="false"
          :optionsToSelect="usersToAdd"
          :initialValue="[]"
          @handleAddTagging="addUser"
        />
      </div>
    </div>

    <div class="row my-4">
      <div class="col-6 col-lg-3">
        <button class="btn btn-outline-primary w-100" @click="goBack">
          Dismiss
        </button>
      </div>
      <div class="col-6 col-lg-3">
        <button 
          :disabled="disableCreateButton"
          class="btn btn-primary w-100" 
          @click="handleCreateNotification"
        >
          Create
        </button>
      </div>
    </div>

  </div>
</template>
<script>
import CaSmttInput from '../../components/ca-smtt-input.vue'
import CaSmttMultiselect from '../../components/ca-smtt-multiselect.vue'
import { getUsers } from '../../services/users/user.api'
import { getGroups } from '../../services/groups/group.api'
import { createNotification } from '../../services/notifications/notification.api'

export default {
  data() {
    return {
      usersToAdd: [],
      groupsToAdd: [],
      title: null,
      message: null,
      disableCreateButton: true,
    }
  },
  async created() {
    await this.getInitialUsers();
    await this.getInitialGroups();
  },
  async mounted() {
    this.$watch(
      () => {
        return [this.title, this.message, this.$refs.users.value, this.$refs.groups.value]
      },
      ([title, message, users, groups]) => {
        this.disableCreateButton = (title === null || title === '') || (message === null || message === '') || (!groups.length && !users.length);
      }
    );
  },
  components: { CaSmttInput, CaSmttMultiselect },
  methods: {
    async handleCreateNotification() {
      try {
        const userIds = this.$refs.users.value.map(user => user.code);
        const groupIds = this.$refs.groups.value.map(group => group.code);
        await createNotification({
          title: this.title,
          message: this.message,
          userIds,
          groupIds,
        });
        this.$toast.open({
          message: 'Notification successfully Created',
          type: 'success'
        })
        this.$router.back();
      } catch (error) {
        console.log(error)
        this.$toast.open({
          message: 'An error occurred',
          type: 'error'
        })
      }
    },
    async getInitialUsers() {
      try {
        const { data } = await getUsers();
        this.usersToAdd = data.users.map(user => ({ code: user.id, name: user.username}));
      } catch (error) {
        console.log(error)
      }
    },
    async getInitialGroups() {
      try {
        const { data } = await getGroups();
        this.groupsToAdd = data.groups.map(group => ({ code: group.id, name: group.group}));
      } catch (error) {
        console.log(error)
      }
    },
    addUser(newUser) {
      const tag = {
        name: newUser,
        code: newUser.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }

      this.usersToAdd.push(tag)
    },
    addGroup(newGroup) {
      const tag = {
        name: newGroup,
        code: newGroup.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }

      this.groupsToAdd.push(tag)
    },
    goBack() {
      this.$router.back()
    },
  },
}
</script>